import { Box, Popover, Slider, Stack, styled } from '@mui/material';

import { colors } from '@watter/shared-components';

import assetLoader from '../../assets/images/heater.png';
import { focuseEffect } from '../../components/common-styles';

export const StyleWrapper = styled(Stack)(({ theme }) => ({
    '& .indexBody': {
        '&.indexBodyLoader': {
            height: 'calc(100dvh - 155px)',
            [theme.breakpoints.down('sm')]: {
                height: 'auto',
            },
        },
        '& .listBlock': {
            height: 'calc(100dvh - 155px)',
            overflow: 'auto',
            [theme.breakpoints.down('sm')]: {
                height: 'calc(100dvh - 190px)',
            },
        },
        '& .assetBlock': {
            '& .MuiBox-root': {
                backgroundImage: `url(${assetLoader})`,
                width: '100%',
                height: '97%',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPositionX: 'center',
            },
        },
    },
    '& .cstNotifyAction': {
        '& .MuiButton-root': {
            boxShadow:
                theme.palette.mode === 'dark'
                    ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                    : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
            color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
            fontSize: theme.spacing(1.25),
            fontFamily: 'good_sansbold',
            textTransform: 'capitalize',
        },
    },
}));

export const SliderUI = styled(Slider)(({ theme }) => ({
    marginBottom: `${theme.spacing(0)}`,
    width: '98%',
    '& .MuiSlider-rail,& .MuiSlider-track': {
        opacity: 1,
        background:
            'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
    },
    '& .MuiSlider-markLabel': {
        transform: 'translate(-50%, -51px)',
        fontSize: theme.spacing(1.5),
        '&:nth-child(4)': {
            left: '4% !important',
        },
        '&:nth-child(6)': {
            left: '52% !important',
        },
        '&:nth-child(8)': {
            left: '96% !important',
        },
    },
    '& .MuiSlider-thumb': {
        '&:before': {
            background: 'linear-gradient(320.66deg, #141515 14.75%, #2E3236 84.81%)',
            border: '0.72px solid #282B2E',
            boxShadow: [2],
        },
        '&:after': {
            width: theme.spacing(1),
            height: theme.spacing(1),
            background: 'linear-gradient(320.66deg, #FDCC3F 14.75%, #FF8524  84.81%)',
        },
        transform: 'translate(-8%, -50%)',
    },
}));

export const DashboardWrapper = styled(Box)(({ theme }) => ({
    height: 'auto',
    overflowY: 'auto',
    maxHeight: '80dvh',
    padding: '0px 10px',
    '& .listBox': {
        padding: theme.spacing(3),
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.whiteSmoke,
        borderRadius: theme.spacing(1),
        '& .MuiTypography-subtitle1': {
            color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
            fontFamily: 'good_sansregular',
        },
        '& .MuiTypography-subtitle2': {
            color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
            fontFamily: 'good_sansregular',
            fontSize: '14px',
        },
        '& .MuiFormControl-root.MuiTextField-root': {
            marginBottom: 0,
            '& .MuiInputBase-root': {
                paddingLeft: 0,
                paddingBottom: 0,
                '& .MuiInputBase-input': {
                    padding: theme.spacing(1.5, 0),
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderRadius: 0,
                    borderWidth: '0px 0px 1px 0px',
                    borderColor: theme.palette.mode === 'dark' ? colors.white : colors.lightGray,
                },
            },
        },
        '& .MuiFormControl-root': {
            '& .MuiFormLabel-root': {
                left: theme.spacing(-2),
                top: theme.spacing(0.25),
                '&.Mui-focused': {
                    color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
                },
            },
        },
        '& .cstMobileNumber': {
            '& .MuiSelect-select[role="combobox"]': {
                padding: theme.spacing(1.5, 0),
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0px 0px 1px 0px',
                borderRadius: '0px',
                borderColor: theme.palette.mode === 'dark' ? colors.white : colors.lightGray,
            },
        },
        '& .cstNoBorder': {
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
    },
    '& .cstActionBtns': {
        '& .MuiButtonBase-root': {
            padding: theme.spacing(2, 0),
            minWidth: theme.spacing(25),
            background: theme.palette.mode === 'dark' ? colors.lightHead : colors.whiteSmoke,
        },
    },
    '& .cstEditProfile': {
        height: 44,
        paddingLeft: 16, // px: 2 = 16px
        paddingRight: 16,
        borderRadius: '22px',
        backgroundColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.whiteSmoke,
        minWidth: 200,
        fontWeight: 500,
        fontSize: '14px',
        '& .MuiSelect-icon': {
            color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
        },
        '& fieldset': {
            border: 'none',
        },
    },
}));
export const CustomTabs = styled(Box)(({ theme }) => ({
    '& .MuiTabs-root': {
        position: 'relative',
        top: '6dvh',
        right: 0,
        minHeight: theme.spacing(5.5),
        borderRadius: theme.spacing(6.25),
        background: theme.palette.mode === 'dark' ? colors.lightHead : colors.whiteSmoke,
        transition: 'left 0.3s ease-in-out',
        '& .MuiTypography-h6': {
            color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
            fontFamily: 'good_sansregular',
        },
        '& .MuiTabs-scroller': {
            '& .MuiTabs-flexContainer': {
                padding: theme.spacing(0.375),
                borderBottom: 'none',
                '& .MuiTab-root': {
                    minHeight: theme.spacing(5),
                    maxHeight: theme.spacing(5),
                    textAlign: 'center',
                    minWidth: theme.spacing(26),
                    padding: 0,
                    transition: 'left 0.3s ease-in-out',
                    '&.Mui-selected': {
                        borderRadius: theme.spacing(6.25),
                        border: 'none',
                        fontWeight: 600,
                        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightGray,
                        color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                    },
                },
            },
            '& .MuiTabs-indicator': {
                display: 'none',
            },
        },
    },
}));

export const UserProfilePicWrapper = styled(Box)(({ theme }) => ({
    '& .userProfilePicBackgroundHover': {
        backgroundColor: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.white,
        position: 'relative',
        borderRadius: '16px',
        '&:hover::after': focuseEffect(),
        padding: '1px',
        zIndex: 1,
        '&:not(:first-of-type)': {
            marginLeft: -16,
        },
    },
    '& .userProfilePicBackground': {
        backgroundColor: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.white,
        borderRadius: '16px',
        padding: '1px',
        position: 'relative',
        zIndex: 1,
        '&:not(:first-of-type)': {
            marginLeft: -16,
        },
    },

    '& .userProfilePic': {
        position: 'relative',
        width: 32,
        height: 32,
        backgroundColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.whiteSmoke,
        fontWeight: 'bold',
        zIndex: 999,
        justifyContent: 'center',
        color: theme.palette.mode === 'dark' ? colors.white : colors.darkBgButton,
    },
    '& .userProfilePicContainer': {
        height: '44px',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,

        padding: '3px 3px',
        borderRadius: '30px',
        gap: ' 8px',
        paddingTop: '4px',
        paddingRight: '8px',
        paddingBottom: '4px',
        paddingLeft: '8px',
    },
    '& .MuiTypography-subtitle1': {
        color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
        fontFamily: 'good_sansregular',
        marginBottom: '10px',
        fontSize: '20px',
        textAlign: 'center',
    },
}));

export const UserListPopupWrapper = styled(Box)(({ theme }) => ({
    '& .userProfilePic': {
        width: 44,
        height: 44,
        backgroundColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.whiteSmoke,
        fontWeight: 'bold',
        zIndex: 999,
        justifyContent: 'center',
    },
    '& .userProfilePicContainer': {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
        padding: '3px 3px',
        borderRadius: '30px',
    },
    '& .MuiTypography-h6': {
        color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
        fontFamily: 'good_sansregular',
        fontWeight: '800',
        fontSize: '12px',
        textAlign: 'center',
        letterSpacing: ' 0.4px',
        marginLeft: '15px',
    },
}));

export const NotifyContainer = styled(Stack)(({ theme }) => ({
    marginTop: '20px',

    '& .cards': {
        borderRadius: theme.spacing(1),
        background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.whiteSmoke,
        marginVertical: '10px',
        '& .unread': {
            width: theme.spacing(1.75),
            height: theme.spacing(1.75),
            borderRadius: '50%',
            background: colors.verifyText,
        },

        '& .subText': {
            color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
        },
    },
}));

export const UserPopUpWrapper = styled(Popover)(({ theme }) => ({
    '& .MuiPopover-paper': {
        zIndex: 0,
        borderRadius: '16px',
        boxShadow: '0px 0px 8px 0px #FFFFFF29',
    },
    '& .cards': {
        padding: '12px 24px',
        height: '250px',

        borderRadius: '16px',
        overflow: 'auto',
        '& .unread': {
            width: theme.spacing(1.75),
            height: theme.spacing(1.75),
            borderRadius: '50%',
            background: colors.verifyText,
        },
        '& .MuiSvgIcon-root[data-testid="DeleteIcon"]': {
            color: theme.palette.mode === 'dark' ? colors.white : colors.gray,
        },
        '& .subText': {
            color: theme.palette.mode === 'dark' ? colors.info : colors.lightHead,
        },
    },
    '& .userProfilePic': {
        width: 40,
        height: 40,
        backgroundColor: theme.palette.mode === 'dark' ? colors.lightHead : colors.whiteSmoke,
        fontWeight: 'bold',
        zIndex: 999,
        justifyContent: 'center',
    },
    '& .userProfilePicContainer': {
        display: 'flex',
        alignItems: 'center',
        backgroundColor: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
        padding: '3px 3px',
        borderRadius: '30px',
    },
    '& .MuiTypography-h6': {
        color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
        fontFamily: 'good_sansregular',
        fontWeight: '800',
        fontSize: '12px',
        textAlign: 'center',
        letterSpacing: ' 0.4px',
        marginLeft: '15px',
    },
    '& .detailContainer': {
        backgroundColor: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
        border: '1px solid var(--Color-tokens-Strokes-Neutral-Light-2, #47474B)',
        boxShadow: '0px 0px 8px 0px #FFFFFF29',
        width: '350px',
        borderRadius: '16px',
        overflow: 'auto',
        padding: '10px 10px',
    },
    '& .userStatusText': {
        width: '100%',
        textAlign: 'left',
        paddingLeft: '12px',
        fontSize: '10px',
        fontFamily: 'good_sansregular',
        color: theme.palette.mode === 'dark' ? colors.info : colors.gray,
    },
    '& .userStatusActiveText': {
        color: '#22C55E',
    },
}));
